var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: { titulo: "Desarquivar processo - " + _vm.numeroProcesso },
      on: { closeModal: _vm.closeModal }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c(
            "validation-observer",
            { ref: "validation", attrs: { tag: "form" } },
            [
              _c("app-display", {
                attrs: {
                  label: "Nome do interessado:",
                  content: _vm.processo.nomeRazaoSocialInteressado
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "CPF/CNPJ do Interessado:",
                  content: _vm.processo.cpfCnpjInteressado
                }
              }),
              _vm.emitirBoleto && !_vm.isMaranhao && !_vm.isAmapa
                ? _c("app-label", {
                    staticClass: "p-top label-desarquivamento",
                    attrs: {
                      label: "Opções de desarquivamento:",
                      required: true
                    }
                  })
                : _vm._e(),
              _vm.emitirBoleto && !_vm.isMaranhao && !_vm.isAmapa
                ? _c("validation-provider", {
                    attrs: { rules: _vm.isObrigatorio() },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c(
                                "el-row",
                                [
                                  !_vm.isMaranhao
                                    ? _c(
                                        "el-radio-group",
                                        {
                                          staticClass: "input",
                                          class: { erro: errors.length },
                                          attrs: {
                                            name: "boleto",
                                            disabled:
                                              _vm.processo.tipoCodigo ===
                                                "REGULARIZACAO_URBANA" ||
                                              _vm.setorLogado === "GDA"
                                          },
                                          model: {
                                            value: _vm.boleto,
                                            callback: function($$v) {
                                              _vm.boleto = $$v
                                            },
                                            expression: "boleto"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "input",
                                              class: { erro: errors.length }
                                            },
                                            [
                                              _c(
                                                "el-radio",
                                                {
                                                  attrs: {
                                                    label: true,
                                                    disabled: _vm.isReurb()
                                                  }
                                                },
                                                [_vm._v("Gerar boleto")]
                                              ),
                                              _c(
                                                "el-radio",
                                                {
                                                  attrs: {
                                                    label: false,
                                                    disabled: _vm.isReurb()
                                                  }
                                                },
                                                [_vm._v("Não gerar boleto")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4070382650
                    )
                  })
                : _vm._e(),
              _vm.boleto !== null
                ? _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.boleto
                          ? "O boleto será gerado no valor de " +
                              (_vm.valorBoleto
                                ? _vm.formatTotal(_vm.valorBoleto)
                                : "xx.xx") +
                              " reais, com data de vencimento para 30 dias após a emissão."
                          : "O processo será desarquivado automaticamente."
                      )
                    )
                  ])
                : _vm._e(),
              _c("app-label", {
                staticClass: "p-top label-desarquivamento",
                attrs: { label: "Mensagem:", required: true }
              }),
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-editor-texto", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { value: _vm.mensagem },
                          on: { onTextChange: _vm.setMensagem }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm.isMaranhao
                ? _c("el-row", { staticClass: "margin-top" }, [
                    _c("p", { staticClass: "label mt-20" }, [
                      _vm._v("Anexos mensagem")
                    ])
                  ])
                : _vm._e(),
              _vm.isMaranhao
                ? _c(
                    "el-row",
                    { staticClass: "margin-top" },
                    [
                      _c("validation-provider", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-anexo", {
                                    attrs: {
                                      id: "upload-anexo-despacho",
                                      exibirDownload: false,
                                      files: _vm.documentos,
                                      scope: "anexos",
                                      tipoExibir: "ANEXO_ANALISE"
                                    },
                                    on: {
                                      removeFile: _vm.removeFile,
                                      uploadFile: _vm.uploadFile
                                    },
                                    model: {
                                      value: _vm.documentos,
                                      callback: function($$v) {
                                        _vm.documentos = $$v
                                      },
                                      expression: "documentos"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1896625407
                        )
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "default", size: "small" },
                on: { click: _vm.closeModal }
              },
              [
                _c("span", { staticClass: "center" }, [
                  _c("i", { staticClass: "fa fa-times" }),
                  _c("b", [_vm._v("  Cancelar")])
                ])
              ]
            ),
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "success", size: "small" },
                on: { click: _vm.enviar }
              },
              [
                _c("span", { staticClass: "center" }, [
                  _c("i", { staticClass: "fa fa-share-square" }),
                  !_vm.isMaranhao && !_vm.isAmapa
                    ? _c("b", [_vm._v("  Enviar")])
                    : _c("b", [_vm._v("  Desarquivar")])
                ])
              ]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fc4abeb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fc4abeb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/modal/AppModalDesarquivarProcesso.vue
// module id = null
// module chunks = 